"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.ExtraBedDto = void 0;
var class_transformer_1 = require("class-transformer");
var class_validator_1 = require("class-validator");
var CribDto = (function () {
    function CribDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], CribDto.prototype, "quantity");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['FREE', 'SURCHARGE']),
        __metadata("design:type", String)
    ], CribDto.prototype, "cost");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], CribDto.prototype, "price");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], CribDto.prototype, "currency");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['PER_DAY', 'PER_NIGHT', 'PER_WEEK', 'PER_STAY']),
        __metadata("design:type", String)
    ], CribDto.prototype, "perTime");
    return CribDto;
}());
var RollawayDto = (function () {
    function RollawayDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], RollawayDto.prototype, "size");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], RollawayDto.prototype, "quantity");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['FREE', 'SURCHARGE']),
        __metadata("design:type", String)
    ], RollawayDto.prototype, "cost");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], RollawayDto.prototype, "price");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], RollawayDto.prototype, "currency");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['PER_DAY', 'PER_NIGHT', 'PER_WEEK', 'PER_STAY']),
        __metadata("design:type", String)
    ], RollawayDto.prototype, "perTime");
    return RollawayDto;
}());
var DayBedDto = (function () {
    function DayBedDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], DayBedDto.prototype, "size");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], DayBedDto.prototype, "quantity");
    return DayBedDto;
}());
var ExtraBedDto = (function () {
    function ExtraBedDto() {
    }
    __decorate([
        class_transformer_1.Type(function () { return CribDto; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", CribDto)
    ], ExtraBedDto.prototype, "crib");
    __decorate([
        class_transformer_1.Type(function () { return RollawayDto; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", RollawayDto)
    ], ExtraBedDto.prototype, "rollaway");
    __decorate([
        class_transformer_1.Type(function () { return DayBedDto; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", DayBedDto)
    ], ExtraBedDto.prototype, "dayBed");
    return ExtraBedDto;
}());
exports.ExtraBedDto = ExtraBedDto;
//# sourceMappingURL=extra-bed.dto.js.map